import * as Yup from "yup";

export default (t: any, stage: number) => {
  return Yup.object().shape(
    stage === 1
      ? {
          userName: Yup.string()
            .typeError(t("UserNameisrequired"))
            .required(t("UserNameisrequired"))
            .min(4, t("UserNamemustbeatleast4chars"))
            .max(50, t("UserNamemustnotexceed50chars"))
            .test(
              "withNoSpace",
              t("UserNameShouldNotContainSpace"),
              function (value) {
                return value.search(" ") < 0;
              }
            ),
        }
      : stage === 2
      ? {
          // otp: Yup.string()
          //   .typeError(t("OTPisrequired"))
          //   .required(t("OTPisrequired"))
          //   .length(4, t("OTPmustbe4chars"))
          //   .test(
          //     "withNoSpace",
          //     t("OTPShouldNotContainSpace"),
          //     function (value) {
          //       return value.search(" ") < 0;
          //     }
          //   ),
        }
      : {
          password: Yup.string()
            .typeError(t("NewPasswordisrequired"))
            .required(t("NewPasswordisrequired"))
            .min(8, t("NewPasswordmustbeatleast8chars"))
            .max(50, t("NewPasswordmustnotexceed50chars")),
          confirmPassword: Yup.string()
            .typeError(t("ConfirmNewPasswordisrequired"))
            .required(t("ConfirmNewPasswordisrequired"))
            .min(8, t("ConfirmNewPasswordmustbeatleast8chars"))
            .max(50, t("ConfirmNewPasswordmustnotexceed50chars")),
        }
  );
};
